(function () {
  'use strict';

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menu = document.querySelector('[data-mobile-menu]');
  var scrim = document.querySelector('[data-menu-scrim]');

  function openMenu() {
    if (!menu) return;
    menu.hidden = false;
    scrim.hidden = false;
    requestAnimationFrame(function () {
      menu.classList.add('is-open');
      scrim.classList.add('is-open');
    });
    menuToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!menu) return;
    menu.classList.remove('is-open');
    scrim.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () {
      menu.hidden = true;
      scrim.hidden = true;
    }, 280);
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', openMenu);
    menuClose.addEventListener('click', closeMenu);
    scrim.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ---------------- Header search ---------------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchPanel = document.querySelector('[data-search-panel]');

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var isHidden = searchPanel.hidden;
      searchPanel.hidden = !isHidden;
      searchToggle.setAttribute('aria-expanded', String(isHidden));
      if (isHidden) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    searchClose.addEventListener('click', function () {
      searchPanel.hidden = true;
      searchToggle.setAttribute('aria-expanded', 'false');
    });
  }

  /* ---------------- Close open <details> nav dropdowns on outside click ---------------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-header__dropdown[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  /* ---------------- Hero slideshow ---------------- */
  document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var dots = root.querySelectorAll('[data-hero-dot]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    var index = 0;
    var timer;

    if (slides.length < 2) return;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === index); });
    }

    function autoplay() {
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, 6500);
    }

    prev.addEventListener('click', function () { show(index - 1); autoplay(); });
    next.addEventListener('click', function () { show(index + 1); autoplay(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { show(parseInt(d.dataset.index, 10)); autoplay(); });
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay();
  });

  /* ---------------- Horizontal sliders (product showcase, etc.) ---------------- */
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var track = root.querySelector('[data-slider-track]');
    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (!track) return;
    function scrollByAmount(dir) {
      var item = track.querySelector(':scope > *');
      var amount = item ? item.getBoundingClientRect().width + 24 : 300;
      track.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { scrollByAmount(-1); });
    if (next) next.addEventListener('click', function () { scrollByAmount(1); });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
    var slides = Array.from(gallery.querySelectorAll('[data-product-slide]'));
    var prev = gallery.querySelector('[data-product-stage-prev]');
    var next = gallery.querySelector('[data-product-stage-next]');

    function activate(id) {
      slides.forEach(function (s) { s.classList.toggle('is-active', s.id === id); });
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.target === id); });
    }
    function currentIndex() {
      return slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.target); });
    });
    if (prev) prev.addEventListener('click', function () {
      var i = currentIndex();
      if (i === -1 || !slides.length) return;
      activate(slides[(i - 1 + slides.length) % slides.length].id);
    });
    if (next) next.addEventListener('click', function () {
      var i = currentIndex();
      if (i === -1 || !slides.length) return;
      activate(slides[(i + 1) % slides.length].id);
    });

    gallery.__activateSlide = activate;
  });

  /* ---------------- Product variant picker ---------------- */
  document.querySelectorAll('[data-product-info]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;

    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var groups = Array.from(root.querySelectorAll('[data-option-index]'));
    var variantInput = root.querySelector('[data-variant-id]');
    var priceValue = root.querySelector('[data-price-value]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var addText = root.querySelector('[data-add-to-cart-text]');
    var block = root.closest('[data-product-block]');
    var gallery = block ? block.querySelector('[data-product-gallery]') : document.querySelector('[data-product-gallery]');

    function selectedValues() {
      return groups.map(function (g) {
        var sel = g.querySelector('.option-pill.is-selected');
        return sel ? sel.dataset.optionValue : null;
      });
    }

    function findVariant(values) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + ' €';
    }

    function refreshAvailability() {
      var current = selectedValues();
      groups.forEach(function (g, gi) {
        Array.from(g.querySelectorAll('.option-pill')).forEach(function (pill) {
          var hypothetical = current.slice();
          hypothetical[gi] = pill.dataset.optionValue;
          var match = findVariant(hypothetical);
          pill.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceValue) priceValue.textContent = formatMoney(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.hidden = false;
          priceCompare.textContent = formatMoney(variant.compare_at_price);
        } else {
          priceCompare.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      if (variant.featured_media && gallery && gallery.__activateSlide) {
        gallery.__activateSlide('ProductMedia-' + variant.featured_media.id);
      }
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var pill = e.target.closest('.option-pill');
        if (!pill) return;
        Array.from(g.querySelectorAll('.option-pill')).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        refreshAvailability();
        updateForVariant(findVariant(selectedValues()));
      });
    });

    refreshAvailability();
  });

  /* ---------------- Dynamic product recommendations ---------------- */
  if (window.customElements && !customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = document.createElement('div');
            doc.innerHTML = text;
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.innerHTML.trim().length) {
              this.innerHTML = fresh.innerHTML;
            } else {
              this.remove();
            }
          }.bind(this))
          .catch(function () {});
      }
    });
  }

  /* ---------------- Collection facets ---------------- */
  var facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    facetForm.querySelectorAll('[data-facet-auto-submit]').forEach(function (input) {
      input.addEventListener('change', function () { facetForm.requestSubmit(); });
    });
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () { facetForm.requestSubmit(); });
    }
  }

  /* ---------------- Cart page ---------------- */
  function initCart() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    function setBusy(isBusy) { root.classList.toggle('is-updating', isBusy); }

    function changeLine(key, quantity) {
      setBusy(true);
      var sectionId = root.dataset.sectionId;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function () { return fetch(window.location.pathname + '?section_id=' + sectionId); })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var fresh = doc.querySelector('[data-cart-root]');
          if (fresh) root.innerHTML = fresh.innerHTML;
          initCart();
          updateCartCount();
        })
        .catch(function () {})
        .finally(function () { setBusy(false); });
    }

    root.querySelectorAll('[data-cart-qty-group]').forEach(function (group) {
      var key = group.dataset.key;
      var input = group.querySelector('[data-cart-qty-input]');
      var dec = group.querySelector('[data-cart-qty-decrease]');
      var inc = group.querySelector('[data-cart-qty-increase]');

      dec.addEventListener('click', function () {
        var qty = Math.max(0, parseInt(input.value, 10) - 1);
        changeLine(key, qty);
      });
      inc.addEventListener('click', function () {
        var qty = parseInt(input.value, 10) + 1;
        changeLine(key, qty);
      });
      input.addEventListener('change', function () {
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(key, qty);
      });
    });

    root.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeLine(btn.dataset.key, 0); });
    });

    var note = root.querySelector('[data-cart-note]');
    if (note) {
      note.addEventListener('change', function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      });
    }
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  initCart();
})();
